<template>
  <div class="body">
    <div class="body_center" v-loading="articleLoading">
      <div class="body_center_left">
        <div class="body_center_left_title">
          首页 / トップ / 正文
        </div>
        <div class="body_center_left_article">
          <div class="body_center_left_article_title">
            {{article.title}}
          </div>
          <div class="body_center_left_article_user">
            <div class="body_center_left_article_user_img"><img :src="article.creator.avatar" /></div>
            <div class="body_center_left_article_user_name">{{article.creator.nickname}}</div>
            <div class="body_center_left_article_user_time">{{timeToStr(article.createdDate)}}</div>
          </div>
          <div class="body_center_left_article_content" v-html="article.content"></div>
          <div class="body_center_left_article_content_details">
            <div class="body_center_left_article_content_details_left">コメント 66</div>
            <div class="body_center_left_article_content_details_right">
              <div class="body_center_left_article_content_details_look"><div class="icon"><img src="@/assets/imgs/article_look.png" /></div><div class="font">{{article.readNum}}</div></div>
              <div class="body_center_left_article_content_details_collect pointer" @click="favoriteFun()"><div class="icon"><img src="@/assets/imgs/article_collect.png" v-if="!article.favorite" /><img src="@/assets/imgs/article_collect_click.png" v-else /></div><div class="font"></div></div>
              <div class="body_center_left_article_content_details_like pointer" @click="likeFun()"><div class="icon"><img src="@/assets/imgs/article_like.png" v-if="!article.like" /><img src="@/assets/imgs/article_like_click.png" v-else /></div><div class="font">{{article.likeNum}}</div></div>
            </div>
          </div>
        </div>
        <article-comment :comments.sync="comments" :article="article" :commentsState="commentsState" v-if="comments"></article-comment>
      </div>
      <div class="body_center_right">
        <article-user :target="article.creator" v-if="article.creator.avatar"></article-user>
        <recruit></recruit>
        <download></download>
      </div>
    </div>
    <article-operate :article="article" v-if="article"></article-operate>
  </div>
</template>

<script>
  import ArticleUser from '@/components/Right/articleUser2'
  import Recruit from '@/components/Right/recruit'
  import Download from '@/components/Right/download'
  import AllianceMedia from '@/components/Right/allianceMedia'
  import HelpfulLinks from '@/components/Right/helpfulLinks'
  import Disclaimers from '@/components/Right/disclaimers'
  import AboutUs from '@/components/Right/aboutUs'
  import articleComment from '@/components/articleDetails/index'
  import articleOperate from '@/components/articleDetails/operate'
  import * as json from '@/assets/js/json'
  import { timeToStr } from '@/assets/js/util'
  export default {
    components: {
      ArticleUser,
      Recruit,
      Download,
      AllianceMedia,
      HelpfulLinks,
      Disclaimers,
      AboutUs,
      articleComment,
      articleOperate
    },
    data () {
      return {
        article:{
          creator:{
            'avatar': null,
            'nickname': null,
          },
          favorite: false,
          'createdDate': null
        },
        comments: null,
        articleLoading: true,
        commentsPage: 1,
        commentsState: true
      }
    },
    created () {
      this.fetch()
      this.commentsPage = 0
      this.getCommentsList()
    },
    methods: {
      fetch(){
        this.articleId = this.$route.query.articleId
        if (!this.articleId && this.articleId <= 0) {
          return
        }
        const option = {
          'articleId': this.articleId
        }
        json.post('/api/member/article/view', option).then((res) =>{
          this.article = res.data.data.article
          this.$store.commit("set_history_list_push",this.article)
          if(res.data.data.comments.length < 7){
            this.commentsState = false
          }
          // this.comments = res.data.data.comments
          // this.comments.sort(function (a,b) {
          //   return b.createdDate - a.createdDate
          // })
          this.articleLoading = false
        })
      },
      addComments(content){
        if(!this.$store.state.token){
          this.$message.error('请先登陆用户')
          return false
        }
        if(!content){
          this.$message.error('请输入评论内容')
          return false
        }
        const option = {
          articleId : this.articleId,
          content : content
        }
        json.post('/api/member/article/comment/add', option).then((res) =>{
          this.commentsPage = 0
          this.article.commentNum ++ 
          this.getCommentsList()
        })
      },
      getCommentsList(){
        this.articleId = this.$route.query.articleId
        if (!this.articleId && this.articleId <= 0) {
          return
        }
        this.commentsPage ++ 
        const option = {
          'articleId': this.articleId,
          'size' : 7,
          'current' : this.commentsPage
        }
        json.post('/api/member/article/comment/list', option).then((res) =>{
          if(!res.data.data.comments.length>0){
            this.commentsState = false
          }
          let mergedArray= null
          if(this.commentsPage>1){
            mergedArray = this.comments.concat(res.data.data.comments) 
          }else{
            mergedArray = res.data.data.comments
          }
          this.comments = null
          this.comments = mergedArray
          this.comments.sort(function (a,b) {
            return b.createdDate - a.createdDate
          })
        })
      },
      favoriteFun(){
        if(!this.$store.state.token){
          this.$message.error('请先登陆用户')
          return false
        }
        const option = {
          'articleId': this.article.id
        }
        if (!this.article.favorite) {
          json.post('/api/member/article/favorite/add', option).then((res) => {
            if (res.data.success) {
              this.article.favorite = true
              this.$notify({
                message: 'お気に入りに登録',
                type: 'success'
              });
            }
          })
        } else {
          json.post('/api/member/article/favorite/delete', option).then((res) => {
            if (res.data.success) {
              this.article.favorite = false
              this.$notify({
                message: 'お気に入りを取消',
                type: 'warning'
              });
            }
          })
        }
      },
      likeFun(){
        if(!this.$store.state.token){
          this.$message.error('请先登陆用户')
          return false
        }
        const option = {
          'articleId': this.article.id
        }
        if(!this.article.like){
          json.post('/api/member/article/like', option).then((res) => {
            if (res.data.success) {
              this.article.like = true
              this.article.likeNum += 1
              this.$notify({
                message: 'お気に入りに登録',
                type: 'success'
              });
            }
          })
        }else{

        }
      },
      onReportFun(option){
        json.post('/api/member/article/report/error/add',option).then((res) => {
          if(res.data.success){
            this.$notify({
              message: '举报成功',
              type: 'success'
            });
          }
        })
      },
      timeToStr (val) {
        return timeToStr(val)
      },
      loginResFun(){
        this.$emit("loginResFun")
      }
    }
  }
</script>

<style scoped>
.body{
  width: 1232px;
  margin: 0 auto;
  margin-top: 27px;
}
.body_center{
  width: 1234px;
  margin: 0 auto;
}
.body_center_left{
  width: 707px;
  padding: 23px 53px;
  min-height: 100px;
  background: #FFFFFF;
}
.body_center_left_title{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
}
.body_center_left_article_title{
  width: 703px;
  font-size: 24px;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
  margin-top: 30px;
  margin-bottom: 9px;
}
.body_center_left_article_user{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 27px;
}
.body_center_left_article_user div{
  display: inline-block;
  vertical-align: middle;
}
.body_center_left_article_user div:nth-child(2){
  margin-left: 8px;
  margin-right: 27px;
}
.body_center_left_article_user_img{
  width: 27px;
  height: 27px;
  border-radius: 50%;
  cursor: pointer;
}
.body_center_left_article_user_img img{
  width: 27px;
  height: 27px;
  border-radius: 50%;
}
.body_center_left_article_content{
  width: 707px;
  min-height: 400px;
  margin: 0 auto;
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  word-wrap: break-word;
  overflow: hidden;
}
.body_center_left_article_content img{
  width: 100%;
}
.body_center_left_article_content p {
  margin: 5px 0;
}
.body_center_left_article_content a{
  display: block;
  font-size: 17px;
  word-wrap: break-word;
}
.body_center_left_article_content span{
  word-break: break-all;
  word-wrap: break-word; 
}
.body_center_left_article_content .imagebox {
  text-align: center;
  max-width: 100%;
}
.body_center_left_article_content_details{
  width: 707px;
  height: 18px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  position: relative;
}
.body_center_left_article_content_details_left{
  position: absolute;
  top: 0;
  left: 0px;
}
.body_center_left_article_content_details_right{
  position: absolute;
  top: 0;
  right: 0px;
}
.body_center_left_article_content_details .icon,.body_center_left_article_content_details .font{
  display: inline-block;
  line-height: 18px;
  vertical-align: middle;
  margin: 0 3.5px;
}
.body_center_left_article_content_details_look ,.body_center_left_article_content_details_collect ,.body_center_left_article_content_details_like{
  display: inline-block;
  margin: 0 22px;
}
.body_center_left_article_content_details img{
  width: 19px;
  height: 18px;
}
</style>
